import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import '../Assets/css/TableDisplay.css'; // Add your CSS styles here

const TableDisplay = ({ content, isUser }) => {
  return (
    <div className={`table-container ${isUser ? 'user' : ''}`}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
  </div>
  );
};

export default TableDisplay;
